import { Component, OnInit, Input, Injectable, forwardRef, Output, EventEmitter } from '@angular/core';
import {
    NgbDateStruct, NgbCalendar, NgbCalendarIslamicUmalqura, NgbDatepickerI18n, 
} from '@ng-bootstrap/ng-bootstrap';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};


let WEEKDAYS = ['ن', 'ث', 'ر', 'خ', 'ج', 'س', 'ح'];
let MONTHS = ['يناير',
    'فبراير',
    'مارس',
    'ابريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'];

const ENGLISH_MONTHS = ['Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'];

const DAYS = ['m', 'th', 'w', 'th', 'f', 's', 's'];
@Injectable()
export class DateI18n extends NgbDatepickerI18n {

    constructor() {
        super();
        if (_spPageContextInfo.currentLanguage == 1033 || _spPageContextInfo.currentLanguage == 1036) {
            MONTHS = [...ENGLISH_MONTHS];
            WEEKDAYS = [...DAYS];
        }
    }

    getWeekdayShortName(weekday: number) {
        return WEEKDAYS[weekday - 1];
    }

    getMonthShortName(month: number) {
        return MONTHS[month - 1];
    }

    getMonthFullName(month: number) {
        return MONTHS[month - 1];
    }

    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}-${date.month}-${date.year}`;
    }
}

@Component({
    selector: 'adahi-gregorian-date-picker',
    templateUrl: './gregorian-date-picker.component.html',
    providers: [
        { provide: NgbDatepickerI18n, useClass: DateI18n },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GregorianDatePickerComponent), multi: true }
    ]
})

export class GregorianDatePickerComponent implements ControlValueAccessor, OnInit {


    ngOnInit(): void {
        if (this.fromToday) {
            this.model = this.minDateInput
            this.value = this.minDateInput
        } else {
            this.minDateInput = { year: this.calendar.getToday().year - this.maxYearsOld, month: 1, day: 1 };
            this.model = this.minDateInput
            this.value = this.minDateInput
        }
        if(this.maxToday){
            this.maxDateInput = { year: this.calendar.getToday().year, month: this.calendar.getToday().month, day: this.calendar.getToday().day };
        }
    }



    model: NgbDateStruct;

    constructor(private calendar: NgbCalendar) {

    }

    selectToday() {
        this.model = this.calendar.getToday();
    }
    @Input() title: string;
    @Input() body: number = 50;
    @Input() fromToday = true;
    @Input() maxToday = false;
    @Input() minDateInput: NgbDateStruct = this.calendar.getToday();
    @Input() maxDateInput: NgbDateStruct = { year: this.calendar.getToday().year+10, month: 12, day: 31 }
    @Input() maxYearsOld:number=5;
    @Output() onChange = new EventEmitter<NgbDateStruct>();

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.model) {
            this.model = value;
        }
    }


    public static Compare(value1: NgbDateStruct,value2: NgbDateStruct){
        if(value1.year>value2.year)
        return 1;
        else if(value2.year>value1.year)
        return 2;
        else
            if(value1.month>value2.month)
                return 1;
            else if(value2.month>value1.month)
                return 2;
            else
                if(value1.day>value2.day)
                    return 1;
                else if(value2.day>value1.day)
                    return 2;
                else
                return 0;
    } 


    compareDate(value: NgbDateStruct,from:boolean): number {
        if (this.model.year > value.year)
            return 0;
        else {
            if (this.model.month > value.month)
                return 0;
            else {
                if ((this.model.day >= value.day&&from)||(this.model.day >= value.day&&!from))
                    return 0;
                else
                    return 1;
            }
        }
    }
    get value(): any {
        return this.model;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.model) {
            this.model = v;
            this.onChangeCallback(v);
        }
    }
    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    changed(e) {
        this.onChange.emit(this.model);
    }

    ResetRanges() {
        this.minDateInput = { year: this.calendar.getToday().year - this.maxYearsOld, month: 1, day: 1 };
        this.maxDateInput = { year: this.calendar.getToday().year + 10, month: 12, day: 31 };
    }

}